const mobileAppsModel = vm => ({
  title: vm.$gettext('Mobile Apps'),
  endpoint: 'mobile-apps',
  allowNew: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: true,
      editable: true,
      required: false
    },
    {
      key: 'meta',
      label: vm.$gettext('Meta'),
      editable: true,
      type: 'JSON'
    }
  ],
  filters: ['id', 'name', 'description'],
  exclude: ['meta']
})

export default mobileAppsModel
